import { VEHICLE_CLASS, type VehicleClass } from "../constants";

const CLASS_BY_TYPE = new Map<string, VehicleClass | null>(Object.entries(VEHICLE_CLASS));

/** Light or heavy class for a body type code, or `null` when it has none. */
export function vehicleClass(vehicleType: string): VehicleClass | null {
  return CLASS_BY_TYPE.get(vehicleType) ?? null;
}
